module.exports = __webpack_public_path__ + "img/03.013fd8a2.png";